export default "__VITE_ASSET__f4b06970__"